import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { TextArea } from "components/DesignSystem/TextArea/TextArea";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import {
  PERK_TYPE_GENERIC,
  PERK_TYPE_INTRO_EMAIL,
  PERK_TYPE_PROMO_CODE,
  PERK_TYPE_SPECIAL_EMAIL,
  PERK_TYPE_SPECIAL_URL,
} from "constants/perksAdmin";
import { useFormikContext } from "formik";
import { PerkFormValues } from "./perksCrm.types";

const EMPTY_INTRO_EMAIL_OPTIONS: { label: string; value: string }[] = [];

export const PerkTypeFields = () => {
  const { values } = useFormikContext<PerkFormValues>();
  const { perk_type: perkType, intro_emails: introEmails } = values;

  if (perkType === PERK_TYPE_PROMO_CODE) {
    return (
      <>
        <TextInput name="promo_code" label="Promo Code" required />
        <TextInput
          name="promo_code_redeem_url"
          label="Promo Code Redeem URL"
          required
        />
      </>
    );
  }

  if (perkType === PERK_TYPE_SPECIAL_URL) {
    return <TextInput name="special_url" label="Special URL" required />;
  }

  if (perkType === PERK_TYPE_INTRO_EMAIL) {
    const introEmailOptions = introEmails.map((email) => ({
      label: email,
      value: email,
    }));

    return (
      <Combobox
        withForm
        isMulti
        creatable
        block
        isClearable={false}
        name="intro_emails"
        label="Intro Emails"
        options={EMPTY_INTRO_EMAIL_OPTIONS}
        value={introEmailOptions}
        placeholder="Type an email and press enter"
      />
    );
  }

  if (perkType === PERK_TYPE_SPECIAL_EMAIL) {
    return (
      <>
        <TextInput name="special_email" label="Special Email" required />
        <TextArea
          name="redeem_instruction"
          label="Redeem Instruction"
          required
          block
        />
      </>
    );
  }

  if (perkType === PERK_TYPE_GENERIC) {
    return (
      <TextArea
        name="generic_instruction"
        label="Generic Instruction"
        required
        block
      />
    );
  }

  return null;
};
